/** @file Root-level exports for `whiteboard-tiptap` */
import type { Content } from '@tiptap/core'
import { AnyExtension, Editor } from '@tiptap/core'
import { Color } from '@tiptap/extension-color'
import TextStyle from '@tiptap/extension-text-style'
import { tipTapDefaultExtensions } from 'tldraw'
import './tiptap_types'

/**
 * Default extensions used by the tldraw tiptap editor
 */
const defaultExtensions = [...tipTapDefaultExtensions, TextStyle, Color] as AnyExtension[]

/**
 * Create a new Tiptap editor for whiteboard text shapes
 * @param content The content to initialize the editor with
 * @param extensions Additional extensions to include (will be appended to defaultExtensions)
 * @returns A new Tiptap editor instance
 */
function createTiptapEditor({ content, extensions = [] }: { content: Content; extensions?: AnyExtension[] }): Editor {
  return new Editor({
    extensions: [...defaultExtensions, ...extensions],
    content,
  })
}

export * from '@tiptap/core'
export { Plugin, PluginKey, type EditorState, type PluginView } from '@tiptap/pm/state'
export { EditorView } from '@tiptap/pm/view'
export { createTiptapEditor, defaultExtensions }

